import React, { FC, PropsWithChildren, useMemo } from 'react';
import { BaseFlexLayoutProps } from './types';

interface ColumnProps extends BaseFlexLayoutProps {}

export const FlexColumn: FC<PropsWithChildren<ColumnProps>> = ({
  children,
  padding = 0,
  margin = 0,
  justifyContent = 'start',
  justifyItems,
  alignContent,
  spaceBetween,
  className,
}) => {
  const JustifyItems = useMemo(
    () => (justifyItems ? `justify-items-${justifyItems}` : ''),
    [justifyItems],
  );
  const AlignContent = useMemo(
    () => (alignContent ? `content-${alignContent}` : ''),
    [alignContent],
  );
  const SpaceBetween = useMemo(
    () => (spaceBetween ? `space-y-${spaceBetween}` : ''),
    [spaceBetween],
  );

  return (
    <div
      className={`w-full flex flex-col p-${padding} m-${margin} justify-${justifyContent} ${JustifyItems} ${AlignContent} ${SpaceBetween} ${
        className || ''
      }`}
    >
      {children}
    </div>
  );
};
